document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
            setTimeout(syncVariantImageToSlideshow, 400);
        }
    });

    // Sync engraving field values between outside-form and inside-form inputs
    syncEngravingFields();
});

function syncEngravingFields() {
    // Find all engraving inputs
    const allInputs = document.querySelectorAll('input[name*="properties["]');
    
    // Group inputs by their property name
    const propertyGroups = {};
    allInputs.forEach(function(input) {
        const match = input.name.match(/properties\[(.*?)\]/);
        if (match) {
            const propertyName = match[1];
            if (!propertyGroups[propertyName]) {
                propertyGroups[propertyName] = [];
            }
            propertyGroups[propertyName].push(input);
        }
    });
    
    // Sync values between grouped inputs
    Object.values(propertyGroups).forEach(function(inputs) {
        if (inputs.length > 1) {
            inputs.forEach(function(input) {
                input.addEventListener('input', function(e) {
                    inputs.forEach(function(otherInput) {
                        if (otherInput !== e.target) {
                            otherInput.value = e.target.value;
                        }
                    });
                });
            });
        }
    });
}

function syncVariantImageToSlideshow() {
        const activeInput = document.querySelector('input[data-current-checked="true"]');
        if (!activeInput) return;
        const swatch = activeInput.closest('label')?.querySelector('.swatch');
        
        if (!swatch) return;
        const style = swatch.getAttribute('style');
        const match = style.match(/url\((.*?)\)/);
        
        if (!match) return;
        let swatchUrl = match[1].replace(/['"]/g, '').replace(/&width=\d+/g, '').replace(/^\/\//, '');
        const thumbnails = document.querySelectorAll('.slideshow-controls__thumbnail');
        thumbnails.forEach((btn) => {
            const img = btn.querySelector('img');
        
            if (!img) return;
            let imgSrc = img.src.replace(/&width=\d+/g, '').replace(/^https?:\/\//, '');
        
            if (imgSrc.includes(swatchUrl.split('/').pop())) {
                thumbnails.forEach(b => b.setAttribute('aria-selected', 'false'));
                btn.setAttribute('aria-selected', 'true');
                btn.click();
            }
        });
    }


// document.addEventListener('VariantUpdateEvent', function (event) {
//     console.log('Variant fully updated!', event.detail);
//     alert("Variant full Updated!");

//   // Your custom code here
//   runMyCustomCode();
// });

// function runMyCustomCode() {
//     console.log('Running custom JS after variant update...');
//     alert("Variant full Updated!");

//   // Example:
//   // Reinitialize sliders
//   // Rebind events
//   // Update custom UI
// }